export default {
	namespaced: true,
	state: () => ({
		isTablet: false,
	}),
	mutations: {
		setTablet(state, tabletState) {
			state.isTablet = tabletState;
		},
	},
	getters: {
		tablet: (state) => state.isTablet,
	},
};
